export default __webpack_public_path__ + "static/media/BirlaTisyaLogoPink.ce40e7f8.webp";